<template lang="pug">
div( v-if="region" )
  payment-order-layout( :regionAlias="region" :sudAlias="sud" )
div( v-else )
  payment-order-change-region-layout
</template>

<script>
import PaymentOrderLayout from '../Layout/PaymentOrderLayout.vue'
import PaymentOrderChangeRegionLayout from '../Layout/PaymentOrderChangeRegionLayout.vue';

export default {
  name: 'PaymentOrderPage',

  components: {
    PaymentOrderLayout,
    PaymentOrderChangeRegionLayout
  },

  props: {
    sud: { type: String, default: "" },
    region: { type: String, default: "" }
  }
}
</script>